<template>
  <v-chip color="grey lighten-3" close @click:close="toggleFilter">
    <v-avatar v-if="filter.icon === 'progress_full' || filter.icon === 'progress_empty'" left>
      <v-progress-circular :rotate="-90" :size="28" :width="2" :value="progressValue" :color="progressColour">
        {{ progressValue }}
      </v-progress-circular>
    </v-avatar>
    <v-icon left v-else>{{ filter.icon }}</v-icon>
    <strong>{{ filter.text }}</strong>
  </v-chip>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'bool-filter-chips',
  props: ['filter', 'prefix'],
  computed: {
    ...mapGetters(['CustomerPageFilters']),
    progressValue: function() {
      return this.filter.icon === 'progress_full' ? 100 : 0;
    },
    progressColour: function() {
      return this.filter.icon === 'progress_full' ? 'accent' : 'grey';
    }
  },
  methods: {
    ...mapActions(['toggleCustomerPageFilter', 'getCustomerPage']),
    getPage: _.debounce(function() {
      this.getCustomerPage(false)
        .then(() => {})
        .catch(error => {
          console.log(error);
        });
    }, 250),
    toggleFilter() {
      this.toggleCustomerPageFilter(this.prefix + this.filter.value).then(() => {
        this.getPage();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
div.input-group {
  padding-top: 0;
}
::v-deep .input-group__details {
  display: none;
}
</style>
